export default "/latin.6438d7b8-860d50.woff2";